import styled from 'styled-components'

import { helpers } from 'styles'

export const Container = styled.div`
	border: 1px solid ${helpers.color.borderMuted};
	background-color: ${helpers.color.background};
	border-radius: 8px;
	padding: 16px;
`
